import axios from 'axios'

class PaymentTypeService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl
  }

  /**
* @author Lucia Alvarado
* @description Get all payment type from a3 cloud 
* @date 30-06-2021
* @param {String} token
* @returns {Object}
* @memberof PaymentTypeService
*/
  async getPaymentType(token) {
    let response = await axios.get(`${this.apiUrl}/payment-type`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data.data
  }

}

export { PaymentTypeService as default }